import { API_CONFIG, apiCall } from './api';

export const settingsAPI = {
  // Fetch all general configs
  getAllGeneralConfigs: async () => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.GENERAL_CONFIG_LIST, {
        method: 'GET',
      });
      return response;
    } catch (error) {
      console.error('Error fetching general configs:', error);
      throw error;
    }
  },

  // Update express delivery settings
  updateExpressDelivery: async (payload) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.GENERAL_CONFIG_EXPRESS, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });
      return response;
    } catch (error) {
      console.error('Error updating express delivery:', error);
      throw error;
    }
  },

  // Update chat support settings
  updateChatConfig: async (payload) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.GENERAL_CONFIG_CHAT, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });
      return response;
    } catch (error) {
      console.error('Error updating chat settings:', error);
      throw error;
    }
  },

  // Update general settings
  updateGeneralSettings: async (payload) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.GENERAL_CONFIG_UPDATE, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });
      return response;
    } catch (error) {
      console.error('Error updating general settings:', error);
      throw error;
    }
  },

  updateTimeSlots: async (payload) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.CONFIG_TIME_SLOT_UPDATE, {
        method: 'POST',
        body: JSON.stringify(payload),
      });
      return response;
    } catch (error) {
      console.error('Error updating time slots:', error);
      throw error;
    }
  },

  updateSpinWheelConfig: async ({
    weeklyWinnersCount,
    giftName,
    nextWinnerSelectionDate,
    giftPhotoFile,
    isGiftEnabled,
    removeGiftPhoto,
  }) => {
    try {
      const formData = new FormData();
      formData.append('weeklyWinnersCount', weeklyWinnersCount);
      formData.append('giftName', giftName);
      formData.append('isGiftEnabled', isGiftEnabled ? 'true' : 'false');
      if (nextWinnerSelectionDate) {
        formData.append('nextWinnerSelectionDate', nextWinnerSelectionDate);
      }
      if (removeGiftPhoto) {
        formData.append('removeGiftPhoto', 'true');
      }
      if (giftPhotoFile instanceof File) {
        formData.append('giftPhoto', giftPhotoFile);
      }
      const response = await apiCall(API_CONFIG.ENDPOINTS.GENERAL_CONFIG_SPIN_WHEEL, {
        method: 'POST',
        body: formData,
      });
      return response;
    } catch (error) {
      console.error('Error updating spin wheel settings:', error);
      throw error;
    }
  },

  // Clear cached homepage content (categories, banners, deal zone, reels)
  clearRedisCache: async () => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.GENERAL_CONFIG_CLEAR_CACHE, {
        method: 'DELETE',
      });
      return response;
    } catch (error) {
      console.error('Error clearing redis cache:', error);
      throw error;
    }
  },

  uploadAdminApp: async ({ version, apkFile }) => {
    try {
      const formData = new FormData();
      formData.append('adminAppVersion', version);
      if (apkFile instanceof File) {
        formData.append('apk', apkFile);
      }
      const response = await apiCall(API_CONFIG.ENDPOINTS.GENERAL_CONFIG_ADMIN_APP, {
        method: 'POST',
        body: formData,
      });
      return response;
    } catch (error) {
      console.error('Error uploading admin app:', error);
      throw error;
    }
  },
};